import express, { Router } from 'express';

import * as permissionValidation from '@/modules/permissions/permissions.validation';
import * as permissionController from '@/modules/permissions/permissions.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions  from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(),
    validateMiddleware(permissionValidation.getPermissions),
    permissionController.getRoleWithPermissions,
  )
  .post(
    userAuthAndCheckPermissions(),
    // validateMiddleware(permissionValidation.createPermissions()),///
    setAuditFields({ mode: AuditMode.CREATE }),
    permissionController.createPermission,
  );

export default router;
